import { cn } from "common/utils/utils";

interface ButtonProps {
  onClick: () => void;
  className?: string;
  iconSrc?: string;
  disabled?: boolean;
}

export const BackwardButton: React.FC<ButtonProps> = ({
  onClick,
  className,
  iconSrc = "/assets/icons/arrow-left-rounded.svg",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "hidden h-[64px] w-[64px] items-center justify-center rounded-full border border-[#FFF3ED] p-0 lg:flex",
        disabled && "pointer-events-none opacity-40",
        className,
      )}
    >
      <img src={iconSrc} alt="previous" className="h-4 w-4" />
    </button>
  );
};

export const ForwardButton: React.FC<ButtonProps> = ({
  onClick,
  className,
  iconSrc = "/assets/icons/arrow-right-rounded.svg",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "hidden h-[64px] w-[64px] items-center justify-center rounded-full bg-[#4FBA6D] p-0 lg:flex",
        disabled && "pointer-events-none opacity-40",
        className,
      )}
    >
      <img src={iconSrc} alt="next" className="h-4 w-4" />
    </button>
  );
};
